export const TABLE_MEASUREMENTS = {
    DEFAULT: {
        headerHeight: 60,
        rowHeight: 60,
    },
    STUDENTS_WITH_OVERALL: {
        headerHeight: 60,
        rowHeight: 80,
    },
};

export const COLUMN_WIDTH = {
    FIRST_COLUMN: 354,
    STUDENT_NAME_COLUMN: 162,
    ADDITIONAL_COLUMN: 88,
};
